import React from 'react';
import { Form, Formik } from 'formik';
import {
  NumberInput,
  Button,
  ISpruceFieldProps,
  SpruceField,
  Grid,
  BodyText,
  BoldBodyText,
  Notification,
  SwitchDialogWindows,
} from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { loanAmountSchema } from '../../../validation/clientPortal/editLoanAmount';

interface IEditLoanAmountFormProps {
  initialValue: number | null;
  onSubmit: (value: number | null) => void;
  onReset: () => void;
  fetchStatus: IFetchStatus;
}

export const EditLoanAmountForm: React.FC<IEditLoanAmountFormProps> = ({
  initialValue,
  onReset,
  onSubmit,
  fetchStatus,
}) => {
  return (
    <Formik
      initialValues={{ loanAmount: initialValue }}
      validationSchema={loanAmountSchema}
      isInitialValid={false}
      onSubmit={(value) => {
        onSubmit(value.loanAmount);
      }}
      onReset={() => onReset()}
    >
      {({ isValid }) => (
        <Form>
          <Grid templateColumns={'1fr min-content'}>
            <Grid>
              <Notification
                type={'warning'}
                mode={'inverted'}
                message={
                  'Changing the Loan Amount will result in some documents regenerating and some fees being recalculated.'
                }
              />
              <Grid templateColumns={'1fr min-content'}>
                <SpruceField name="loanAmount">
                  {({ field }: ISpruceFieldProps) => (
                    <>
                      <NumberInput
                        value={field.value}
                        onChange={field.onChange}
                        errorText={field.errorText}
                        prefix={'$'}
                        mode={'currency'}
                      />

                      <Button intent={'primary'} type={'submit'} disabled={!isValid}>
                        Confirm
                      </Button>
                    </>
                  )}
                </SpruceField>
              </Grid>
            </Grid>
            <Button isInline intent={'ghost'} type={'reset'}>
              Cancel
            </Button>
          </Grid>

          <SwitchDialogWindows
            isCompleted={fetchStatus.fetched}
            isError={fetchStatus.fetched && !fetchStatus.success}
            isLoading={fetchStatus.fetching}
            onCloseClick={() => onReset()}
            loadingMessage={'Working...'}
            successTitle={'Loan Amount has been updated!'}
            successMessage={
              <div>
                <BodyText>Fees were recalculated.</BodyText>
                <div>
                  <BoldBodyText as={'span'}>Important: </BoldBodyText>
                  &nbsp;
                  <BodyText as={'span'}>documents may take a moment to regenerate.</BodyText>
                </div>
              </div>
            }
            errorMessage={'Loan Amount cannot be updated. Contact Spruce about this issue.'}
          />
        </Form>
      )}
    </Formik>
  );
};
